/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OSDiscountCodeDto } from './OSDiscountCodeDto';
import {
    OSDiscountCodeDtoFromJSON,
    OSDiscountCodeDtoFromJSONTyped,
    OSDiscountCodeDtoToJSON,
} from './OSDiscountCodeDto';

/**
 * 
 * @export
 * @interface OSDiscountDto
 */
export interface OSDiscountDto {
    /**
     * 
     * @type {number}
     * @memberof OSDiscountDto
     */
    discountId: number;
    /**
     * 
     * @type {string}
     * @memberof OSDiscountDto
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof OSDiscountDto
     */
    active: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OSDiscountDto
     */
    deleted: boolean;
    /**
     * 
     * @type {number}
     * @memberof OSDiscountDto
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof OSDiscountDto
     */
    expirationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof OSDiscountDto
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof OSDiscountDto
     */
    validFrom: string;
    /**
     * 
     * @type {boolean}
     * @memberof OSDiscountDto
     */
    isAllSectionsSelected: boolean;
    /**
     * 
     * @type {Array<OSDiscountCodeDto>}
     * @memberof OSDiscountDto
     */
    discountCodes: Array<OSDiscountCodeDto>;
    /**
     * 
     * @type {Set<string>}
     * @memberof OSDiscountDto
     */
    sectionIds: Set<string>;
}

/**
 * Check if a given object implements the OSDiscountDto interface.
 */
export function instanceOfOSDiscountDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "discountId" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "active" in value;
    isInstance = isInstance && "deleted" in value;
    isInstance = isInstance && "amount" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "validFrom" in value;
    isInstance = isInstance && "isAllSectionsSelected" in value;
    isInstance = isInstance && "discountCodes" in value;
    isInstance = isInstance && "sectionIds" in value;

    return isInstance;
}

export function OSDiscountDtoFromJSON(json: any): OSDiscountDto {
    return OSDiscountDtoFromJSONTyped(json, false);
}

export function OSDiscountDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OSDiscountDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'discountId': json['discountId'],
        'name': json['name'],
        'active': json['active'],
        'deleted': json['deleted'],
        'amount': json['amount'],
        'expirationDate': !exists(json, 'expirationDate') ? undefined : json['expirationDate'],
        'type': json['type'],
        'validFrom': json['validFrom'],
        'isAllSectionsSelected': json['isAllSectionsSelected'],
        'discountCodes': ((json['discountCodes'] as Array<any>).map(OSDiscountCodeDtoFromJSON)),
        'sectionIds': json['sectionIds'],
    };
}

export function OSDiscountDtoToJSON(value?: OSDiscountDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'discountId': value.discountId,
        'name': value.name,
        'active': value.active,
        'deleted': value.deleted,
        'amount': value.amount,
        'expirationDate': value.expirationDate,
        'type': value.type,
        'validFrom': value.validFrom,
        'isAllSectionsSelected': value.isAllSectionsSelected,
        'discountCodes': ((value.discountCodes as Array<any>).map(OSDiscountCodeDtoToJSON)),
        'sectionIds': Array.from(value.sectionIds as Set<any>),
    };
}

